"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _constant = require("../constant");

var _chinaDisclaimer = _interopRequireDefault(require("./chinaDisclaimer.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DisclaimerOverlay = _styledComponents.default.div.withConfig({
  displayName: "ChinaDisclaimer__DisclaimerOverlay",
  componentId: "sc-j0l15l-0"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:-1;background-color:", ";opacity:0;transition:ease-out 0.3s;&.open{z-index:1000000;opacity:0.5;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyDarker;
});

var DisclaimerContainer = _styledComponents.default.div.withConfig({
  displayName: "ChinaDisclaimer__DisclaimerContainer",
  componentId: "sc-j0l15l-1"
})(["position:fixed;width:520px;height:382px;left:0;right:0;top:0;bottom:0;z-index:1000001;margin:auto;mix-blend-mode:normal;box-shadow:0px 8px 24px rgba(0,0,0,0.24);background-color:", ";border-radius:", ";overflow:hidden;animation:Moveup 0.2s linear;@media screen and (max-width:", "){width:92%;}@keyframes Moveup{0%{top:100vh;}100%{top:0px;}}"], function (_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      theme = _ref2.theme;
  return theme.backgroundColor[backgroundColor];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius.normal;
}, _constant.BREAKPOINTS.SMALL_TABLET);

var CloudAnimation = _styledComponents.default.div.withConfig({
  displayName: "ChinaDisclaimer__CloudAnimation",
  componentId: "sc-j0l15l-2"
})(["position:relative;height:216px;@media screen and (max-width:", "){height:200px;}.cloud0{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud1-desktop.png ');background-repeat:no-repeat;background-size:41.57px 19.4px;position:absolute;width:41.57px;height:19.4px;top:166px;visibility:hidden;animation:MoveLeft0 3s linear infinite;@keyframes MoveLeft0{0%{left:455px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.cloud1{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud2-desktop.png ');background-repeat:no-repeat;background-size:54px 25px;position:absolute;width:54px;height:25px;top:134px;visibility:hidden;animation:MoveLeft1 2.5s linear infinite;animation-delay:1.5s;@keyframes MoveLeft1{0%{left:450px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.cloud2{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud3-desktop.png ');background-repeat:no-repeat;background-size:69px 33px;position:absolute;width:69px;height:33px;top:78px;visibility:hidden;animation:MoveLeft2 2s linear infinite;animation-delay:1s;@keyframes MoveLeft2{0%{left:453px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.cloud3{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud4-desktop.png ');background-repeat:no-repeat;background-size:81px 33px;position:absolute;width:81px;height:33px;top:48px;visibility:hidden;animation:MoveLeft3 2s linear infinite;animation-delay:0.5s;@keyframes MoveLeft3{0%{left:430px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.flight{background-image:url('https://a.staticaa.com/images/misc/popup-animation-plane-desktop.png');background-repeat:no-repeat;background-size:251.14px 63.37px;position:absolute;left:137.28px;top:91.64px;width:251.14px;height:63.37px;animation:MoveUpDown 2s linear infinite;@keyframes MoveUpDown{0%,100%{top:91.64px;}50%{top:80px;}}}@media screen and (max-width:", "){.cloud0{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud1-mobile.png');background-repeat:no-repeat;background-size:35.01px 16.34px;position:absolute;width:35.01px;height:16.34px;top:123.89px;visibility:hidden;animation:MoveLeft0 3s linear infinite;@keyframes MoveLeft0{0%{left:305px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.cloud1{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud2-mobile.png');background-repeat:no-repeat;background-size:45.47px 21.05px;position:absolute;width:45.47px;height:21.05px;top:110.42px;visibility:hidden;animation:MoveLeft1 2.5s linear infinite;animation-delay:1.5s;@keyframes MoveLeft1{0%{left:300px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.cloud2{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud3-mobile.png');background-repeat:no-repeat;background-size:58.11px 27.79px;position:absolute;width:58.11px;height:27.79px;top:63.26px;visibility:hidden;animation:MoveLeft2 2s linear infinite;animation-delay:1s;@keyframes MoveLeft2{0%{left:285px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.cloud3{background-image:url('https://a.staticaa.com/images/misc/popup-animation-cloud4-mobile.png');background-repeat:no-repeat;background-size:68.21px 27.79px;position:absolute;width:68.21px;height:27.79px;top:38px;visibility:hidden;animation:MoveLeft3 2s linear infinite;animation-delay:0.5s;@keyframes MoveLeft3{0%{left:280px;visibility:visible;}100%{left:0px;visibility:hidden;}}}.flight{background-image:url('https://a.staticaa.com/images/misc/popup-animation-plane-mobile.png');background-repeat:no-repeat;background-size:212.98px 53.36px;position:absolute;left:67.63px;top:74.75px;width:212.98px;height:53.36px;animation:MoveUpDown 2s linear infinite;@keyframes MoveUpDown{0%,100%{top:67.63px;}50%{top:55px;}}}}"], _constant.BREAKPOINTS.SMALL_TABLET, _constant.BREAKPOINTS.SMALL_TABLET);

var DisclaimerContent = _styledComponents.default.div.withConfig({
  displayName: "ChinaDisclaimer__DisclaimerContent",
  componentId: "sc-j0l15l-3"
})(["width:84.61%;margin:0 auto;"]);

var ChinaDisclaimer = function ChinaDisclaimer(props) {
  var content = props.content,
      open = props.open,
      productId = props.productId,
      redirect = props.redirect,
      backgroundColor = props.backgroundColor,
      customProperties = props.customProperties,
      accessible = props.accessible,
      theme = props.theme,
      noRedirection = props.noRedirection;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      productDetail = _useState2[0],
      setProductDetail = _useState2[1];

  var _useState3 = (0, _react.useState)(5),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      countdown = _useState4[0],
      setCountdown = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showWindow = _useState6[0],
      setShowWindow = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      formattedLine1Part1 = _useState8[0],
      setFormattedLine1Part1 = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      formattedLine1Part2 = _useState10[0],
      setFormattedLine1Part2 = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      formattedLine2 = _useState12[0],
      setFormattedLine2 = _useState12[1];

  var _useState13 = (0, _react.useState)(redirect),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      redirectionUrl = _useState14[0],
      setRedirectionUrl = _useState14[1];

  var tempRedirect = redirect;

  var _useState15 = (0, _react.useState)(true),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      newTab = _useState16[0],
      setNewTab = _useState16[1];

  var disclaimerTimeout;
  (0, _react.useEffect)(function () {
    setRedirectionUrl(redirect);
  }, [redirect]);

  var customEventAfterClose = function customEventAfterClose() {
    var evt = new CustomEvent('chinadisclaimerclosed', {
      detail: 'false'
    });

    if (typeof window !== 'undefined') {
      window.dispatchEvent(evt);
    }
  };

  var buildDisclaimer = function buildDisclaimer(product) {
    if (!product) {
      return;
    }

    var line1 = product.cnDisclaimerLine1 || product.cndisclaimerLine1;
    var line2 = product.cnDisclaimerLine2 || product.cndisclaimerLine2;
    var disclaimerURL = product.cnDisclaimerURL || product.chinaURL;
    var aaGo = redirect && redirect.indexOf(_constant2.AIRASIA_GO.URL) >= 0;
    var companyURL = aaGo ? _constant2.AIRASIA_GO.URL : product.redirectCompanyURL || product.companyURL;
    var companyName = aaGo ? _constant2.AIRASIA_GO.COMPANY_NAME : product.redirectCompanyName || product.companyName;
    setNewTab(product.newTab.toLowerCase() === 'true');
    setCountdown(product.countDownTimer || product.countDown);

    if (!redirectionUrl || redirectionUrl === '') {
      tempRedirect = product.redirectionUrl || product.url;
      setRedirectionUrl(tempRedirect);
    }

    var formattedLine1 = line1 && line1.replace('{0}', disclaimerURL).replace('{1}', companyURL);
    var newLine2 = line2 && line2.replace('{1}', companyURL).replace('{2}', companyName);
    var formattedLine1Split = formattedLine1 && formattedLine1.split('{3}');

    if (formattedLine1Split) {
      setFormattedLine1Part1(formattedLine1Split[0]);
      setFormattedLine1Part2(formattedLine1Split[1]);
    }

    setFormattedLine2(newLine2);
  };

  (0, _react.useEffect)(function () {
    var product = content.find(function (c) {
      return c.productID === productId;
    });
    setProductDetail(product);
    buildDisclaimer(product); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content, productId]);

  var openURL = function openURL() {
    var openType = !newTab ? '_parent' : '_blank';

    if (typeof window !== 'undefined' && !noRedirection) {
      window.open(redirectionUrl || tempRedirect, openType);
    }

    customEventAfterClose();
    setShowWindow(false);
  };

  var startTimer = function startTimer() {
    if (!productDetail) {
      return;
    }

    if (countdown <= 0) {
      clearTimeout(disclaimerTimeout);
      openURL();
    } else {
      disclaimerTimeout = setTimeout(function () {
        setCountdown(countdown - 1);
      }, 1000);
    }
  };

  (0, _react.useEffect)(function () {
    // eslint-disable-next-line no-unused-expressions
    open ? startTimer() : openURL();
    return function () {
      clearTimeout(disclaimerTimeout);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown]);

  var getMain = function getMain() {
    if (!productDetail || !showWindow) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    return formattedLine1Part1 && formattedLine1Part2 && formattedLine2 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(DisclaimerOverlay, {
      className: "open"
    }), /*#__PURE__*/_react.default.createElement(DisclaimerContainer, (0, _extends2.default)({
      id: "china-disclaimer-widget",
      backgroundColor: backgroundColor,
      tabIndex: tabIndex
    }, customProperties), /*#__PURE__*/_react.default.createElement(CloudAnimation, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "cloud0"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "cloud1"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "cloud2"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "cloud3"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "flight"
    })), /*#__PURE__*/_react.default.createElement(DisclaimerContent, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      marginBottom: "normal",
      theme: theme
    }, formattedLine1Part1, countdown, formattedLine1Part2), /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme
    }, formattedLine2))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

ChinaDisclaimer.propTypes = _chinaDisclaimer.default.PropTypes;
ChinaDisclaimer.defaultProps = _chinaDisclaimer.default.DefaultProps;
var _default = ChinaDisclaimer;
exports.default = _default;